import {
  Link as ChakraLink,
  LinkProps as ChakraLinkProps
} from "@chakra-ui/react"
import { MouseEventHandler, forwardRef } from "react"
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
  useInRouterContext
} from "react-router-dom"

export type LinkProps = ChakraLinkProps & RouterLinkProps

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, to, ...props }, ref) => {
    const inRouterContext = useInRouterContext()

    const handleMouseDown: MouseEventHandler<HTMLAnchorElement> = (e) =>
      e.preventDefault() // avoid validating any form elements via onBlur handlers, see: https://github.com/redux-form/redux-form/issues/860#issuecomment-625254444

    return inRouterContext ? (
      <ChakraLink
        asChild
        ref={ref}
        variant="underline"
        onMouseDown={handleMouseDown}
        {...props}
      >
        <RouterLink to={to}>{children}</RouterLink>
      </ChakraLink>
    ) : (
      <ChakraLink
        ref={ref}
        variant="underline"
        onMouseDown={handleMouseDown}
        {...props}
      >
        {children}
      </ChakraLink>
    )
  }
)

Link.displayName = "Link"

export default Link
